<!-- results-table.component.html -->
<h1 mat-dialog-title>Controles</h1>
<div mat-dialog-content>

  <div class="content p-24"  *ngIf="tieneAnalisisIhnerente">

      <div fxLayout="row" xFlex="100">

          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">

              <div class="profile-box info-box general" fxLayout="column">

                <table class="summary">
                    <!--<tr>
                        <td class="label">Escenario</td>
                        <td class="value">{{escenario.nombre}}</td>
                    </tr>-->

                    <tr>
                        <td class="label">Objetivo</td>
                        <td class="value">{{objetivoRiesgo.objetivo.nombre}}</td>
                    </tr>

                    <tr>
                        <td class="label">Riesgo</td>
                        <td class="value">{{objetivoRiesgo.riesgo.nombre}}</td>
                    </tr>

                </table>
              </div>
          </div>


          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">
            <div class="profile-box info-box general" fxLayout="column">
              <table class="summary">


                <tr>
                  <td class="label">Cantidad de controles</td>
                  <td class="value">{{objetivoRiesgo.cantidadControles}}</td>
                </tr>
                <tr>
                  <td class="label">Probabilidad inherente</td>
                  <td class="value">{{objetivoRiesgo.topAnalisisInherente?.probabilidad?.nombre}} ({{objetivoRiesgo.topAnalisisInherente?.probabilidad?.valor | number:'1.2-2'}})</td>
                </tr>
                <tr>
                  <td class="label">Impacto inherente</td>
                  <td class="value">{{objetivoRiesgo.topAnalisisInherente?.impacto?.nombre}} ({{objetivoRiesgo.topAnalisisInherente?.impacto?.valor | number:'1.2-2'}})</td>
                </tr>

              </table>
          </div>
      </div>
    </div>
  </div>          
    <!-- CONTENT CARD -->
    <div class="content-card" [hidden]="!tieneAnalisisIhnerente">

      <mat-tab-group animationDuration="0ms" >
        {{objetivoRiesgo.topAnalisisInherente}}
        <mat-tab label="Controles instalados">

            <!-- CONTENT -->
              <div class="editor content" fxFlexLayout="row" *ngIf="action!='View'">
                <div class="content p-10" fxFlexLayout="row">
                  <div fxFlex="50">
                    <!--
                    <mat-form-field fxFlex>
                      <mat-label>Control</mat-label>
                      <mat-select [(ngModel)]="new_line_p.control" class="roleSelect">
                          <mat-option *ngFor="let control of controles" [value]="control.nombre">
                              {{control.nombre}}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>-->
                    <mat-form-field style="margin-right:10px;" fxFlex>
                      <mat-label>Control</mat-label>
                      <input type="text"
                            placeholder="Control"
                            aria-label="Control"
                            matInput
                            [formControl]="myControl"
                            [matAutocomplete]="auto"
                            [(ngModel)]="control"
                            >

                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)"
                            >
                              <mat-option *ngFor="let option of filteredControles | async" [value]="option">
                                {{option.nombre}}
                              </mat-option>
                              <mat-option (click)="agregarControl()">
                                <a>Agregar</a>
                              </mat-option>
                            </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <div fxFlex="50">
                    <mat-label class="px-20">Estructura Jerarquica:</mat-label>

                    <span *ngIf="new_line_p.estructura!=null && new_line_p.nodo!=null" class="px-20">{{new_line_p.estructura?.nombre}} / {{new_line_p.nodo?.nombre}}</span>
                    <button mat-button mat-raised-button (click)="openDialog()">Seleccionar nodo</button>
                  </div>
                </div>
                <div class="content p-10">
                  <mat-form-field style="margin-right:10px;" fxFlex="20">
                    <input placeholder="Costo" matInput [(ngModel)]="new_line_p.costo">
                  </mat-form-field>
                  <mat-form-field style="margin-right:10px;" fxFlex="20">
                    <input placeholder="Esfuerzo" matInput [(ngModel)]="new_line_p.esfuerzo">
                  </mat-form-field>

                  <mat-form-field style="margin-right:10px;" fxFlex="20">
                    <mat-label>Probabilidad residual</mat-label>
                    <mat-select [(ngModel)]="new_line_p.probabilidad" class="roleSelect" [compareWith]="compareObjects">
                        <mat-option *ngFor="let probabilidad of escenario.probabilidades" [value]="probabilidad">
                            {{probabilidad.nombre}} ({{probabilidad.valor | number:'1.2-2'}})
                        </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field style="margin-right:10px;" fxFlex="20">
                    <mat-label>Impacto residual</mat-label>
                    <mat-select [(ngModel)]="new_line_p.impacto" class="roleSelect" [compareWith]="compareObjects">
                        <mat-option *ngFor="let impacto of escenario.impactos" [value]="impacto">
                            {{impacto.nombre}} ({{impacto.valor | number:'1.2-2'}})
                        </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row">Agregar</button>

                </div>
              </div>
              <div class="content p-24">
                <table mat-table [dataSource]="objetivoRiesgo.analisisResidual" #tableProbabilidad class="my-table mat-elevation-z8 select-list" >

                  <ng-container matColumnDef="control">
                    <th mat-header-cell *matHeaderCellDef> Control </th>
                    <td mat-cell *matCellDef="let element"> {{element?.control}} </td>
                  </ng-container>

                  <ng-container matColumnDef="estructura">
                    <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
                    <td mat-cell *matCellDef="let element"> {{element?.nodoEstructuraNombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="nodo">
                    <th mat-header-cell *matHeaderCellDef> Nodo </th>
                    <td mat-cell *matCellDef="let element"> {{element.nodoNombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="costo">
                    <th mat-header-cell *matHeaderCellDef> Costo </th>
                    <td mat-cell *matCellDef="let element"> {{element?.costo}} </td>
                  </ng-container>

                  <ng-container matColumnDef="esfuerzo">
                    <th mat-header-cell *matHeaderCellDef> Esfuerzo </th>
                    <td mat-cell *matCellDef="let element"> {{element?.esfuerzo}} </td>
                  </ng-container>

                  <ng-container matColumnDef="probabilidad">
                    <th mat-header-cell *matHeaderCellDef> Probabilidad </th>
                    <td mat-cell *matCellDef="let element">
                      <span matTooltip="{{element.probabilidad?.nombre}}"
                      matTooltipPosition="right">
                      {{element.probabilidad?.valor | number:'1.2-2'}}
                      </span>
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="impacto">
                    <th mat-header-cell *matHeaderCellDef> Impacto residual </th>
                    <td mat-cell *matCellDef="let element">
                      <span matTooltip="{{element.impacto?.nombre}}"
                      matTooltipPosition="right">{{element.impacto?.valor | number:'1.2-2'}}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="exposicion">
                    <th mat-header-cell *matHeaderCellDef> Exposición </th>
                    <td mat-cell *matCellDef="let element"> {{element.exposicion | number:'1.2-2'}} </td>
                  </ng-container>

                  <ng-container matColumnDef="clasificacion">
                    <th mat-header-cell *matHeaderCellDef> Clasificación </th>
                    <td mat-cell *matCellDef="let element"> {{element?.clasificacion}} </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Acción </th>
                    <td mat-cell *matCellDef="let element; let i = index;" class="action-link">
                      <a (click)="edit(element,i)" *ngIf="action!='View'">Editar</a> <span  *ngIf="objetivoRiesgo.analisisResidual.length>1 && action!='View'">|</span>
                      <a (click)="remove(element,i)" *ngIf="objetivoRiesgo.analisisResidual.length>1 && action!='View'">Eliminar</a>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </div>

            <!-- / CONTENT -->
          </mat-tab>

      </mat-tab-group>

    </div>
    <!-- / CONTENT CARD -->



</div>
<div *ngIf="!tieneAnalisisIhnerente">
  <strong>Falta realizar el análisis de riesgo inherente.</strong>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action!='View' && objetivoRiesgo.topAnalisisInherente.probabilidad!=null">Modificar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
</div>
